import type { InvoiceTransactionAml, TransactionAmlBadgeState } from '../model/types';

export const getTransactionAmlBadgeState = (
  aml?: InvoiceTransactionAml | null
): TransactionAmlBadgeState | null => {
  if (!aml) return null;

  if (!aml.executed || aml.isPending) {
    return 'pending';
  }

  if (aml.isOk) {
    return 'ok';
  }

  return 'risk';
};

export const formatAmlRiskscorePercent = (riskscore?: number | null): string => {
  if (riskscore === null || riskscore === undefined) {
    return '-';
  }

  return `${(Number(riskscore) * 100).toFixed(1)}%`;
};

export interface AmlSignalItem {
  key: string;
  label: string;
  value: number;
}

export const getPositiveAmlSignals = (
  signals?: Record<string, number>
): AmlSignalItem[] => {
  if (!signals || typeof signals !== 'object') {
    return [];
  }

  return Object.entries(signals)
    .filter(([, value]) => Number(value) > 0)
    .map(([key, value]) => ({
      key,
      label: key.replace(/_/g, ' '),
      value: Number(value),
    }))
    .sort((a, b) => b.value - a.value);
};

export const AML_BADGE_VARIANT_CLASSES: Record<TransactionAmlBadgeState, string> = {
  pending: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
  ok: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300',
  risk: 'bg-destructive/15 text-destructive',
};
